// Uniform 1:1 fields only; asymmetric cases stay in each mapper.
export const SELECTOR_FIELDS = [
  {
    formField: 'completeInformationFormId',
    backendKey: 'form',
    labelKey: 'name',
    extras: ['internalName'],
  },
  { formField: 'nextActionId', backendKey: 'nextAction', labelKey: 'name', extras: ['type'] },
  {
    formField: 'nextActionIfFalseId',
    backendKey: 'nextActionIfFalse',
    labelKey: 'name',
    extras: ['type'],
  },
  {
    formField: 'allowedAppClientId',
    backendKey: 'allowedApplication',
    labelKey: 'applicationName',
  },
  { formField: 'connectionId', backendKey: 'connection', labelKey: 'name', extras: ['type'] },
  { formField: 'processId', backendKey: 'process', labelKey: 'name' },
  {
    formField: 'actionToExecuteId',
    backendKey: 'actionToExecute',
    labelKey: 'name',
    extras: ['type'],
  },
  { formField: 'sequenceId', backendKey: 'sequence', labelKey: 'name' },
  { formField: 'rpaAgentId', backendKey: 'rpaAgent', labelKey: 'name' },
  { formField: 'rpaFlowId', backendKey: 'rpaFlow', labelKey: 'name' },
  { formField: 'integrationId', backendKey: 'integration', labelKey: 'name' },
  { formField: 'integrationFunctionId', backendKey: 'integrationFunction', labelKey: 'name' },
];

export const BOOL_FIELDS = [
  { formField: 'isActive', backendKey: 'enabled' },
  { formField: 'isAutoOpenEditOperationEnabled', backendKey: 'autoOpenEditOperation' },
  { formField: 'isCompletedOptionDisabled', backendKey: 'disableComplete' },
  { formField: 'saveButtonDisabled', backendKey: 'hideSaveButton' },
  { formField: 'cancelButtonDisabled', backendKey: 'hideCancelButton' },
  { formField: 'isInternalExecutionAllowed', backendKey: 'allowedInternalExecution' },
];

export function selectorToForm(obj, labelKey) {
  return typeof obj === 'object' ? { label: obj[labelKey], value: obj.id, ...obj } : obj;
}

export function selectorToBackend(sel, labelKey, extras) {
  const out = { id: sel.value || sel.id, [labelKey]: sel.label || sel[labelKey] };
  if (extras) {
    for (const key of extras) {
      if (sel[key]) out[key] = sel[key];
    }
  }
  return out;
}
